<template>
  <!-- <div class="container-fluid mt--7"> -->
  <div class="row">
    <div class="col">
      <b-modal
        v-if="convertedJson != null && convertedJson != ''"
        id="user-group-modal"
        size="xl"
      >
        <template slot="modal-header">Form Preview</template>
        <template slot="default">
          <dynamic-form
            :convertedJson="convertedJson"
            :key="refreshKey"
            ref="dynamicForm"
          ></dynamic-form>
        </template>
      </b-modal>

      <a-drawer
        title=""
        :width="480"
        placement="right"
        @close="onClose"
        :visible="visible"
      >
        <div v-if="formId == 'addCategory'">
          <h6 class="heading-small text-muted mb-4">Add Category</h6>
          <form>
            <base-input
              alternative=""
              label="Name"
              placeholder=""
              v-model="selectedTitle"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Code"
              placeholder=""
              v-model="selectedCode"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Reference Code"
              placeholder=""
              v-model="selectedRefCode"
              input-classes="form-control"
            />
            <div
              class="float-right"
              style="position: absolute; bottom: 20px; right: 20px"
            >
              <button class="btn btn-success" @click="createData">
                Create
              </button>
              <button class="btn" @click.prevent="onClose">Cancel</button>
            </div>
          </form>
        </div>
        <div v-if="formId == 'editCategory'">
          <h6 class="heading-small text-muted mb-4">Edit Category</h6>
          <form>
            <base-input
              alternative=""
              label="Name"
              placeholder=""
              v-model="selectedTitle"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Code"
              placeholder=""
              v-model="selectedCode"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Reference Code"
              placeholder=""
              v-model="selectedRefCode"
              input-classes="form-control"
            />
            <div
              class="float-right"
              style="position: absolute; bottom: 20px; right: 20px"
            >
              <button class="btn btn-success" @click.prevent="updateData">
                Update
              </button>
              <button class="btn" @click.prevent="onClose">Cancel</button>
            </div>
          </form>
        </div>
        <div v-if="formId == 'addHeader'">
          <h6 class="heading-small text-muted mb-4">Add Header</h6>
          <h5>
            This will serve as a header/grouping for the categories you will be
            creating
          </h5>
          <br />
          <form>
            <base-input
              alternative=""
              label="Header Name"
              placeholder=""
              v-model="selectedTitle"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Sequence"
              type="number"
              placeholder=""
              v-model="selectedSequence"
              input-classes="form-control"
            />
            <div
              class="float-right"
              style="position: absolute; bottom: 20px; right: 20px"
            >
              <button class="btn btn-success" @click="createData">
                Create
              </button>
              <button class="btn" @click.prevent="onClose">Cancel</button>
            </div>
          </form>
        </div>
        <div v-if="formId == 'editHeader'">
          <h6 class="heading-small text-muted mb-4">Edit Header</h6>
          <h5>
            This will serve as a header/grouping for the categories you will be
            creating
          </h5>
          <br />
          <form>
            <base-input
              alternative=""
              label="Header Name"
              placeholder=""
              v-model="selectedTitle"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Sequence"
              type="number"
              placeholder=""
              v-model="selectedSequence"
              input-classes="form-control"
            />
            <div
              class="float-right"
              style="position: absolute; bottom: 20px; right: 20px"
            >
              <button class="btn btn-success" @click.prevent="updateData">
                Update
              </button>
              <button class="btn" @click.prevent="onClose">Cancel</button>
            </div>
          </form>
        </div>
      </a-drawer>

      <!-- max-height: 60vh; overflow: scroll; -->
      <div class="card mb-3" style="min-height: 60vh">
        <div class="row no-gutters">
          <div
            class="col-md-5"
            style="border-right: 1px solid #e0e0e0; min-height: 60vh"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-8 no-gutters">
                  <h2 class="card-title">Setting Categories</h2>
                </div>
                <div class="col-md-4">
                  <button
                    @click.prevent="showDrawer('addHeader')"
                    type="button"
                    class="btn btn-sm btn-default ml-1 float-right"
                  >
                    Add Header
                  </button>
                </div>
              </div>

              <!-- <ul class="list-group list-group-flush" style="width: 100%">
                          <li class="list-group-item" style="font-size: 14px" v-for="header in headerList" @click="headerClick(header)">
                            <h4>{{header.name}}</h4>
                            <dynamic-tree :headerId="header.id" :key="componentKey" @selectNode="selectNode"></dynamic-tree>
                          </li>
                        </ul> -->

              <a-collapse
                v-model="activeKey"
                @change="headerClick"
                :accordion="accordion"
              >
                <!-- :header="header.name" -->
                <a-collapse-panel
                  v-for="header in headerList"
                  :key="header.id.toString()"
                >
                  <template slot="header">
                    {{ header.name }}
                    <div class="float-right mr-2">
                      <a-dropdown>
                        <a class="ant-dropdown-link" href="#">
                          <span class="fa fa-ellipsis-v"></span>
                        </a>
                        <a-menu slot="overlay">
                          <a-menu-item key="1" @click="headerAction(header, 1)">
                            Edit Header
                          </a-menu-item>
                          <!-- <a class="btn btn-danger btn-sm text-white">Delete</a> -->
                          <a-menu-item key="2">
                            <a-popconfirm
                              title="You are about to delete this header?"
                              @confirm="headerAction(header, 2)"
                              okText="Delete"
                              cancelText="Cancel"
                            >
                              Delete Header
                            </a-popconfirm>
                          </a-menu-item>
                        </a-menu>
                      </a-dropdown>
                    </div>
                  </template>
                  <dynamic-tree
                    :headerId="header.id"
                    :key="componentKey"
                    @selectNode="selectNode"
                    :defaultSelected="false"
                  ></dynamic-tree>
                </a-collapse-panel>
              </a-collapse>

              <!-- <a-input style="margin-bottom: 8px" placeholder="Search Categories" @change="onChange" />
                        <a-tree class="draggable-tree" :defaultExpandedKeys="expandedKeys" :expandedKeys="expandedKeys"
                          :autoExpandParent="autoExpandParent" draggable @expand="onExpand" @select="onSelect" 
                          :treeData="gData" ref="nodes">
                            <template slot="title" slot-scope="{title}">
                              <span v-if="title.indexOf(searchValue) > -1">
                                {{title.substr(0, title.indexOf(searchValue))}}
                                <span style="color: #f50">{{searchValue}}</span>
                                {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
                              </span>
                              <span v-else>{{title}} </span>
                            </template>
                        </a-tree> -->

              <br /><br /><br /><br />
            </div>

            <div
              style="
                position: absolute;
                bottom: 0px;
                right: 0px;
                width: -webkit-fill-available;
                background-color: #f2f2f2;
                padding: 10px;
              "
            >
              <!-- <button  v-if="selectedHeader != null" @click.prevent="showDrawer('addHeader')" type="button" class="btn ml-1 btn-sm btn-default float-right"> Edit Header </button> -->
              <button
                v-if="showAddCategory == true"
                @click.prevent="showDrawer('addCategory')"
                type="button"
                class="btn mr-2 btn-sm btn-primary float-right"
              >
                Add Category
              </button>
              <!-- <button v-if="selectedNode != null" @click.prevent="showDrawer('addCategory')" type="button" class="btn btn-sm btn-success float-right"> Add Category </button>  -->
              <button
                v-if="selectedNode != null"
                @click.prevent="showDrawer('editCategory')"
                type="button"
                class="btn btn-sm btn-success float-right mr-2"
              >
                Edit Category
              </button>
              <button
                v-if="selectedNode != null"
                class="btn btn-sm mr-2 float-right btn-danger"
              >
                <a-popconfirm
                  title="You are about to delete this record?"
                  @confirm="deleteData"
                  okText="Delete"
                  cancelText="Cancel"
                  >Delete Category</a-popconfirm
                >
              </button>
            </div>
          </div>
          <div
            class="col-md-7"
            style="border-right: 1px solid #e0e0e0; min-height: 60vh"
          >
            <div class="card-body">
              <a-tabs defaultActiveKey="1">
                <a-tab-pane tab="Builder" key="1">
                  <div class="row">
                    <div v-if="selectedNode != null" class="col-md-8">
                      <h2 class="card-title">
                        Settings Builder - {{ selectedNode.title }}
                      </h2>
                    </div>
                    <div v-else class="col-md-8">
                      <h2 class="card-title">Settings Builder</h2>
                    </div>
                    <div class="col-md-4 float-right">
                      <button
                        class="btn btn-sm btn-default"
                        style="border-radius: 24px; border: 0px; width: 100%"
                      >
                        Cheat Sheet
                      </button>
                    </div>
                  </div>

                  <div
                    v-if="selectedNode != null"
                    class="row"
                    style="overflow: scroll"
                  >
                    <div
                      v-if="selectedNode.children.length == 0"
                      class="col-md-12"
                    >
                      <base-input alternative="">
                        <textarea
                          v-model="jsonField"
                          rows="20"
                          class="form-control"
                        />
                      </base-input>
                    </div>
                    <div v-else class="col-md-12">
                      <small
                        >Please select a leaf category to build settings.</small
                      >
                    </div>
                  </div>
                  <div v-else class="row col-md-12" style="overflow: scroll">
                    <small
                      >Please select a leaf category to build settings.</small
                    >
                  </div>

                  <br /><br /><br /><br />
                </a-tab-pane>
                <a-tab-pane tab="JSON Viewer" key="2">
                  <div class="row col-md-12">
                    <vue-json-pretty :data="JSON.parse(convertedJson)">
                    </vue-json-pretty>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </div>

            <div
              v-if="selectedNode != null"
              style="
                position: absolute;
                bottom: 0px;
                right: 0px;
                width: -webkit-fill-available;
                background-color: #f2f2f2;
                padding: 10px;
              "
            >
              <button
                type="button"
                class="btn btn-sm btn-primary float-right"
                v-b-modal.user-group-modal
                @click="refreshKey++"
              >
                Preview
              </button>
              <button
                type="button"
                class="btn btn-sm btn-success mr-2 float-right"
                @click.prevent="updateTemplate"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import LicensesTable from './Tables/LicensesTable.vue'
// import ProfilesTable from './Tables/PosProfilesTable.vue'
import HTTPRequest from "../controllers/httpRequest.js";
// import FilterBar from './FilterBar'
import DynamicForm from "./DynamicForm.vue";
import DynamicTree from "./DynamicTree.vue";
import { mapState, mapActions } from "vuex";

var ObjGen = require("../../node_modules/objgen/objgen.js").ObjGen;

import VueJsonPretty from "vue-json-pretty";

// var conditionResult = []

export default {
  components: {
    // ProfilesTable,
    // FilterBar,
    // LicensesTable,
    VueJsonPretty,
    DynamicForm,
    DynamicTree,
  },
  mounted: async function () {
    this.headerList = await HTTPRequest.getRequest(
      this.endPoint +
        "terminal_settings_category_headers?header_type=" +
        this.$attrs.headerType,
      null,
      null
    );
    // this.gData = await HTTPRequest.getRequest(this.endPoint + '/terminal_settings_categories/tree_view', null)
    // gData = this.gData
    // generateList(gData)
  },
  computed: {
    ...mapState(["currentProfile", "currentApiURL", "endPoint", "parameters"]),
    // ...mapState(['endPoint', 'currentProfile', 'parameters', 'serverType']
  },
  data() {
    return {
      // defaultExpandAll: true,
      activeKey: null,
      refreshKey: 0,
      convertedJson: null,
      jsonField: "",
      licenseStats: "",
      componentKey: 0,
      filterStatus: "",
      checkedValues: [],
      // expandedKeys: [],
      searchValue: "",
      // autoExpandParent: true,
      // gData,
      visible: false,
      formId: "",
      selectedNode: null,
      selectedKey: null,
      selectedTitle: "",
      selectedCode: "",
      selectedSequence: "",
      selectedRefCode: "",
      selectedProfile: "system_modules",
      //   serverType: "ho"
      headerListComponent: 0,
      headerList: null,
      showAddCategory: false,
      selectedHeader: null,
      accordion: true,
    };
  },
  watch: {
    // selectedProfile: async function(){
    //   if (this.selectedProfile == "terminals") {
    //       var stats = await HTTPRequest.getRequest(this.endPoint + "licenses/get_stats" , null)
    //       this.licenseStats =  stats["active_license"] +  "/" +  stats["no_of_license"]
    //   }
    // },
    jsonField: function () {
      if (this.jsonField != null)
        this.convertedJson = ObjGen.xJson(this.jsonField, { numSpaces: 2 });
      else this.convertedJson = null;
    },
  },
  methods: {
    headerAction(header, key) {
      this.selectedKey = header.id;
      if (key == "1") {
        this.showDrawer("editHeader");
        this.selectedTitle = header.name;
        this.selectedSequence = header.sequence;
      } else {
        this.selectedNode == null;
        this.deleteData();
      }
    },
    selectNode(value) {
      // alert("NODE SELECTED!!!!")
      this.selectedNode = value;
      this.jsonField = value.scopedSlots.settings_template;
      // console.log(value)
    },
    headerClick() {
      this.showAddCategory = true;
      this.selectedHeader = this.activeKey;
      // alert(this.activeKey)
      this.selectedNode = null;
      this.componentKey++;
    },
    // !!! START - DRAWERS
    showDrawer(formId) {
      this.formId = formId;
      this.visible = true;
      if (this.formId == "editCategory") {
        this.selectedTitle = this.selectedNode.scopedSlots.title;
        this.selectedCode = this.selectedNode.scopedSlots.code;
        this.selectedRefCode = this.selectedNode.scopedSlots.reference_code;
      }
      // if(formId == 'addCategory'){
      //     this.clearData()
      //     this.visible = true
      // } else {
      //     this.visible = true
      // }
    },
    onClose() {
      this.clearData();
      // this.selectedTitle = null
      this.visible = false;
    },
    async createData() {
      if (this.formId == "addHeader") {
        var headerPayload = {
          terminal_settings_category_header: {
            name: this.selectedTitle,
            status: "A",
            sequence: this.selectedSequence,
            header_type: this.$attrs.headerType,
          },
        };
        await HTTPRequest.postRequest(
          this.endPoint + "terminal_settings_category_headers/",
          null,
          headerPayload
        );
        this.headerList = await HTTPRequest.getRequest(
          this.endPoint +
            "terminal_settings_category_headers?header_type=" +
            this.$attrs.headerType,
          null,
          null
        );
        this.clearData();
        this.onClose();
      } else {
        if (this.selectedNode == null) {
          this.selectedKey = null;
        } else {
          this.selectedKey = this.selectedNode.key;
        }
        var categoryPayload = {
          terminal_settings_category: {
            name: this.selectedTitle,
            code: this.selectedCode,
            reference_code: this.selectedRefCode,
            status: "A",
            parent_id: this.selectedKey,
            terminal_settings_category_header_id: this.selectedHeader,
          },
        };
        await HTTPRequest.postRequest(
          this.endPoint + "terminal_settings_categories/",
          null,
          categoryPayload
        );
        // gData = this.gData
        // generateList(gData)
        // this.headerList = await HTTPRequest.getRequest(this.endPoint + 'terminal_settings_category_headers/' , null, null)
        this.componentKey++;
        alert("Create Successful");
        this.clearData();
        this.onClose();
      }

      // if(this.selectedNode == null){
      //     this.selectedKey = null
      // }
      // var categoryPayload = {terminal_settings_category: {name: this.selectedTitle, code: this.selectedCode, reference_code: this.selectedRefCode, status: 'A', parent_id: this.selectedKey} }
      // this.gData = await HTTPRequest.postRequest(this.endPoint + 'terminal_settings_categories/' , null, categoryPayload)
      // gData = this.gData
      // generateList(gData)
      // alert("Create Successful")
      // this.clearData()
      // this.onClose()
    },
    async updateData() {
      if (this.formId == "editHeader") {
        var headerPayload = {
          terminal_settings_category_header: {
            name: this.selectedTitle,
            sequence: this.selectedSequence,
            status: "A",
          },
        };
        await HTTPRequest.putRequest(
          this.endPoint +
            "terminal_settings_category_headers/" +
            this.selectedKey,
          null,
          headerPayload
        );
        this.headerList = await HTTPRequest.getRequest(
          this.endPoint +
            "terminal_settings_category_headers?header_type=" +
            this.$attrs.headerType,
          null,
          null
        );
        this.clearData();
        this.onClose();
      } else {
        var categoryPayload = {
          terminal_settings_category: {
            name: this.selectedTitle,
            code: this.selectedCode,
            reference_code: this.selectedRefCode,
          },
        };
        await HTTPRequest.putRequest(
          this.endPoint +
            "terminal_settings_categories/" +
            this.selectedNode.key,
          null,
          categoryPayload
        );
        this.componentKey++;
        alert("Update Successful");
        this.clearData();
        this.onClose();
      }
    },
    async deleteData() {
      if (this.selectedNode == null) {
        var headerPayload = {
          terminal_settings_category_header: { status: "D" },
        };
        await HTTPRequest.putRequest(
          this.endPoint +
            "terminal_settings_category_headers/" +
            this.selectedKey,
          null,
          headerPayload
        );
        this.headerList = await HTTPRequest.getRequest(
          this.endPoint +
            "terminal_settings_category_headers?header_type=" +
            this.$attrs.headerType,
          null,
          null
        );
        this.clearData();
      } else {
        var categoryPayload = { terminal_settings_category: { status: "D" } };
        await HTTPRequest.putRequest(
          this.endPoint +
            "terminal_settings_categories/" +
            this.selectedNode.key,
          null,
          categoryPayload
        );
        // this.headerList = await HTTPRequest.getRequest(this.endPoint + 'terminal_settings_category_headers/' , null, null)
        this.componentKey++;
      }
      // gData = this.gData
      // generateList(gData)
      // this.clearData()
      // alert("Delete Successful")
      // this.onClose()
    },
    async updateTemplate() {
      var categoryPayload = {
        terminal_settings_category: { settings_template: this.jsonField },
      };
      console.log(categoryPayload);
      await HTTPRequest.putRequest(
        this.endPoint +
          "terminal_settings_categories/" +
          this.selectedNode.key +
          "?header_id=" +
          this.selectedHeader,
        null,
        categoryPayload
      );
      alert("Update Successful");
      this.onClose();
    },
    // !!! END - DRAWERS
    refreshPage() {
      this.visible = false;
      this.componentKey++;
    },
    clearData() {
      this.selectedKey = null;
      this.selectedTitle = null;
      this.selectedSequence = null;
      // this.selectedCode = null
      // this.selectedRefCode = null
    },

    // TREE FUNCTIONS
    // onExpand  (expandedKeys) {
    //   this.selectedNode = null
    //   this.expandedKeys = expandedKeys
    //   this.autoExpandParent = false
    // },
    // onChange (e) {
    //   const value = e.target.value
    //   const expandedKeys = dataList.map((item) => {
    //     if (item.title.indexOf(value) > -1) {
    //       return getParentKey(item.key, gData)
    //     }
    //     return null
    //   }).filter((item, i, self) => item && self.indexOf(item) === i)
    //   Object.assign(this, {
    //     expandedKeys,
    //     searchValue: value,
    //     autoExpandParent: true,
    //   })
    // },
    // async onSelect(info){
    //     var selectedNode = getNode(info[0], gData)
    //     this.selectedNode = selectedNode
    //     this.selectedKey = selectedNode.key
    //     this.selectedCode = selectedNode.scopedSlots.code
    //     this.selectedRefCode = selectedNode.scopedSlots.reference_code
    //     this.selectedTitle = selectedNode.title
    //     this.jsonField = selectedNode.scopedSlots.settings_template
    // },

    ...mapActions(["updateCurrentProfile", "updateParameters"]),
    // setCurrentProfile(profile){
    //     this.selectedProfile = profile
    //     if(profile == "terminals" || profile == "payment_types"){
    //         this.updateCurrentProfile(profile)
    //     }
    // },
    // changeFilter(statusFilter, searchFilter, searchText){
    // //   console.log(statusFilter)
    //   this.filterStatus = statusFilter
    //   if(statusFilter == "0"){
    //       console.log(this.parameters)
    //       this.updateParameters("?" + searchFilter + "=" + searchText)
    //       console.log(this.parameters)
    //   } else if( statusFilter == "A"){
    //       this.updateParameters("?" + searchFilter + "=" + searchText + "&status=A")
    //   } else {
    //       this.updateParameters("?" + searchFilter + "=" + searchText + "&status=I")
    //   }

    // },
  },
};
</script>

<style>
.ant-collapse > .ant-collapse-item-active > .ant-collapse-header {
  background-color: #32325d;
  color: white;
}
</style>
